export const PASSWORD_ERROR_MESSAGE =
  'Password must be at least 8 characters with uppercase, lowercase, number and special character';

export const PASSWORD_REQUIREMENTS = [
  'At least 8 characters long',
  'One uppercase letter (A-Z)',
  'One lowercase letter (a-z)',
  'One number (0-9)',
  'One special character (for example: ! @ # $ % .)'
];

export const validatePassword = password => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
  return passwordRegex.test(password);
};

export const getPasswordStrength = password => {
  let strength = 0;
  if (password.length >= 8) strength++;
  if (/[a-z]/.test(password)) strength++;
  if (/[A-Z]/.test(password)) strength++;
  if (/\d/.test(password)) strength++;
  if (/[^A-Za-z\d]/.test(password)) strength++;
  return strength;
};

export const getPasswordStrengthText = strength => {
  switch (strength) {
    case 0:
    case 1:
      return { text: 'Very Weak', color: 'bg-red-500' };
    case 2:
      return { text: 'Weak', color: 'bg-orange-500' };
    case 3:
      return { text: 'Fair', color: 'bg-yellow-500' };
    case 4:
      return { text: 'Good', color: 'bg-blue-500' };
    case 5:
      return { text: 'Strong', color: 'bg-green-500' };
    default:
      return { text: 'Very Weak', color: 'bg-red-500' };
  }
};
